import React from 'react';
import ReactApexChart from "react-apexcharts";

const GeneralStatisticChart = ({ data }) => {
    const series = data;
    const options = {
        labels: ['Dostupni', 'Prodani', 'Na čekanju'], // Labels for the donut chart
        chart: {
            type: 'donut',
            height: 350,
        },
        plotOptions: {
            pie: {
                size: 100,
                offsetX: 0,
                offsetY: 0,
                donut: {
                    size: "70%",
                    labels: {
                        show: true,
                        name: {
                            show: true,
                            fontSize: '13px',
                            offsetY: -5,
                        },
                        value: {
                            show: true,
                            fontSize: '13px',
                            color: '#343a40',
                            fontWeight: 500,
                            offsetY: 5,
                            formatter: function (val) {
                                return val.toLocaleString() + " KM";
                            },
                        },
                        total: {
                            show: true,
                            fontSize: '13px',
                            label: 'Ukupna vrijednost',
                            color: '#9599ad',
                            fontWeight: 500,
                            formatter: function (w) {
                                return w.globals.seriesTotals.reduce((a, b) => a + b, 0).toLocaleString() + " KM";
                            },
                        },
                    },
                },
            },
        },
        dataLabels: {
            enabled: false,
        },
        legend: {
            show: true,
            position: 'bottom',
            horizontalAlign: 'center',
            markers: {
                width: 10,
                height: 10,
            },
        },
        colors: ['#28a745', '#007bff', '#ffc107'], // Colors for segments
        stroke: {
            lineCap: "round",
            width: 2,
        },
    };

    

    return (
        <React.Fragment>
            <ReactApexChart
                options={options}
                series={series}
                type="donut"
                height="350"
                className="apex-charts"
            />
        </React.Fragment>
    );
};

export default GeneralStatisticChart;